<template>
  <div
    v-if="isHeader"
    class="row"
  >
    <div 
      v-for="(column, index) in columns" 
      :key="'header_' + index"
      :ref="'header_' + index"
      :class="className(index)"
      @click="$emit('cell-click', {tag, position: {col:index, row:undefined}, value: data})"
      @mouseover="$emit('cell-mouseover', {tag, position: {col:index, row:undefined}, value: data})"
    >
      <div class="p-1 h-100">
        {{ column.label }}
      </div>
    </div>
  </div>

  <div
    v-else
    class="row"
    :class="{'is-hidden': datas[0].always_visible === false && expand === false}"
  >
    <div
      v-for="(data, index) in datas"
      :key="'value_' + index"
      :ref="'value_' + index"
      :class="className(index)"
      :data-cy="'cell_' + index + '_' + lineNumber"
      @click="$emit('cell-click', {tag, position: {col:index, row:lineNumber}, value: data})"
      @mouseover="$emit('cell-mouseover', {tag, position: {col:index, row:lineNumber}, value: data})"
    >
      <div
        v-if="index === 0"
        class="h-100 d-flex justify-content-between align-items-center p-1"
      >
        <div v-html="data.label" />
        <sl-tooltip
          v-if="data.value && data.value.moreInfo"
          :content="data.value.moreInfo"
        />
      </div>
      <div
        v-else
        class="p-1"
        v-html="columns[index].format(data.label)"
      />
    </div>
  </div>
</template>

<script>
import SlTooltip from "src/modules/shared/components/SlTooltip";
/**
 * Ligne de Tableau SwissLife
 * Un simple ligne
 */
export default {
  name: 'SlTableRow',
  components: { SlTooltip },
  props: {
    // determine si la ligne est un header
    // par conséquent il utilise le label de columns
    isHeader: {
      type: Boolean,
      require: false,
      default: false
    },
    // la description des colonnes ainsi que les fonctions de formatage
    columns: {
      type: Array,
      required: true
    },
    // les données organisées en simple tableau
    datas: {
      type: Array,
      required: true
    },
    currentPositionSelected: {
      type: Object,
      required: false
    },
    // le numéro de ligne courante
    lineNumber: {
      type: Number,
      required: true
    },
    // l'écart +/- autour de la selection
    range: {
      type: Number,
      required: false,
    },
    // un identifiant de tableau
    tag: {
      type: String,
      required: true
    },
    expand: {
      type: Boolean,
      required: true
    }
  },
  emits: [
    'cell-click',
    'cell-mouseover'
  ],
  setup(props) {
    /**
     * Détermine le type de style en fonction de l'index de la colonne
     */
    const className = (col) => {
      let selectors =  col === 0 ? 'item col-3 flex-nowrap' : 'item col p-1 d-flex justify-content-center align-items-center text-center flex-nowrap clickable'
      const position = props.currentPositionSelected
      // garde fou
      if (!position) {
        return
      }

      // si la colonne correspond à la sélection
      const colSelected = position.col
      const range = props.range

      if(col === colSelected) {
        if(typeof position.row === 'undefined') {
          // si la ligne n'est pas renseigné, alors la colonne du tableau sera sélectionnée
          selectors += ' selected'
        } else if(props.lineNumber === position.row || props.lineNumber === -1) {
          // sinon on doit uniquement selectionner la cellule en question
          selectors += ' selected'
        } else {
          // dans les autres cas
          selectors += ' in-range-selection'
        }
      } else if(col >= (colSelected - range) && col <= (colSelected + range) ) {
        // si la colonne fait partie des colonnes autour de la sélection
        selectors += ' in-range-selection'
      } else if(col !== 0) {
        // sinon par défaut
        selectors += ' disabled'
      }

      return selectors
    }

    return {
      className
    }
  }

}
</script>

<style lang="scss" scoped>
@import "src/scss/variables.scss";

  .item {
    border: 0.063rem solid $border-color;
    border-bottom: none;
    border-top: none;
  }
  .item + .item {
    border-left:none;
  }
  .row{
    border-bottom: 0.063rem solid $border-color;
  }
  .row:first-child{
    border-top: 0.063rem solid $border-color;
  }
  .selected {
    background-color: $cell-selected;
    color: white;
  }
  .in-range-selection {
    background-color: white;
  }
  .disabled {
    background-color: $cell-disabled;
  }

  .clickable {
    cursor: pointer;
  }

  .row .selected p {
    color: white
  }
</style>

<style lang="scss">
  #app .selected p {
    color: white
  }
  #app .row.is-hidden {
    display: none;
  }
  #app p {
    margin-bottom:0 !important;
    sup {
      font-size: 0.65em;
    }
  }
</style>

